<template>
    <b-input-group>
        <b-form-select
            v-model="status"
            :options="status_options"
            :disabled="read_only"
        ></b-form-select>
        <template #append v-if="!hide_button">
            <b-button variant="primary" @click="apply" :disabled="disable">
                <template v-if="submitting">
                  <i class="fal fa-spinner fa-spin" />{{ " Applies..." }}
                </template>
                <template v-else>Submit</template>
            </b-button>
        </template>
    </b-input-group>
</template>

<script>
export default {
    name: "ToggleSelectButton",
    props: {
        status_options: {
            type: Array,
            default: () => []
        },
        default_value: {
            type: String,
            default: () => null
        },
        hide_button: {
            type: Boolean,
            default: () => false
        },
        read_only: {
            type: Boolean,
            default: () => false
        },
    },
    data() {
        return {
            status: this.default_value,
            disable: false,
            submitting: false,
        };
    },
    watch: {
        "default_value"() {
            this.status = this.default_value;
        }
    },
    methods: {
        apply() {
            this.$emit('selectedOption', this.status);
        }
    },
};
</script>